import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "custom-upload-st2" }
const _hoisted_3 = ["id", "accept"]
const _hoisted_4 = { class: "s4 custom-upload-img" }
const _hoisted_5 = { class: "s12" }
const _hoisted_6 = { class: "custom-upload-text" }
const _hoisted_7 = { class: "custom-upload-text-sm" }

import { reactive } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPayslipUploadInput',
  props: {
  id: { type: String, required: true },
  caption: { type: String, default: '' },
  label: { type: String, default: 'Fichier' }
},
  emits: ["uploaded"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const extensionsAllowed = ['.pdf', '.doc', '.docx', '.xls', '.xlsx']
const formValue = reactive({
  file: null as File | null,
  file_name: ''
})

function onFileUploaded(event: Event) {
  const input = event.target as HTMLInputElement
  if (!input.files || input.files.length === 0) {
    return
  }
  const file = input.files[0]
  formValue.file = file
  formValue.file_name = file.name
  emit('uploaded', {
    file,
    file_name: file.name
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: props.id,
    class: _normalizeClass(["custom-upload my-5", { active: formValue.file }])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: props.id,
        class: "display-none",
        type: "file",
        onChange: onFileUploaded,
        accept: extensionsAllowed.join(',')
      }, null, 40, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.caption), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(props.label), 1),
        _cache[0] || (_cache[0] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(formValue.file_name ? formValue.file_name : 'Charger le doc'), 1)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "s4 right" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-upload.svg",
          class: "custom-upload-icon"
        })
      ], -1))
    ])
  ], 10, _hoisted_1))
}
}

})